import { Heart, ShieldCheck, Sparkles } from "lucide-react";
import { Outlet } from "react-router-dom";
import { Brand } from "../../design-system";

export function AuthLayout() {
  return (
    <main className="auth-layout">
      <section className="auth-story" aria-label="Sobre o programa">
        <Brand />
        <div className="auth-story__content">
          <span className="eyebrow eyebrow--light">
            <Sparkles size={15} /> Parcerias que transformam vidas
          </span>
          <h1>Indicar cuidado também merece reconhecimento.</h1>
          <p>
            Acompanhe cada indicação com transparência, acumule pontos e
            transforme conexões em benefícios.
          </p>
          <div className="auth-story__proof">
            <span>
              <ShieldCheck /> Dados protegidos
            </span>
            <span>
              <Heart /> Jornada transparente
            </span>
          </div>
        </div>
        <p className="auth-story__footer">Programa de indicações da clínica</p>
      </section>
      <section className="auth-panel">
        <div className="auth-panel__inner">
          <Outlet />
        </div>
      </section>
    </main>
  );
}
